// Fenetre Google/Facebook (popup) fermee ou abandonnee : Firebase met
// plusieurs secondes a le constater, et l'ecran de connexion restait bloque
// sur « Connexion en cours… ». Des que l'utilisateur revient sur l'app
// (focus ou onglet a nouveau visible), on debloque l'interface apres un court
// delai de grace. La promesse Firebase continue : si la connexion aboutit
// quand meme, l'etat d'authentification est mis a jour normalement.
export const POPUP_RETURN_GRACE_MS = 1200;

export function watchReturnFromPopup(onReturn, graceMs = POPUP_RETURN_GRACE_MS) {
  if (typeof window === "undefined") return () => {};
  let timer = null;
  let done = false;
  const schedule = () => {
    if (done || timer) return;
    if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
    timer = window.setTimeout(() => {
      timer = null;
      if (done) return;
      done = true;
      onReturn();
    }, graceMs);
  };
  const onVisibility = () => {
    if (document.visibilityState === "visible") schedule();
  };
  window.addEventListener("focus", schedule);
  document.addEventListener("visibilitychange", onVisibility);
  return () => {
    done = true;
    if (timer) window.clearTimeout(timer);
    window.removeEventListener("focus", schedule);
    document.removeEventListener("visibilitychange", onVisibility);
  };
}

const POPUP_CANCEL_CODES = new Set(["auth/popup-closed-by-user", "auth/cancelled-popup-request"]);

export function isPopupCancelError(error) {
  return POPUP_CANCEL_CODES.has(error?.code);
}
